import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

import { Modal } from '@b-stock/fe-core/bstock-react'
import { Colors, Typography } from '@b-stock/fe-core/design-system'

// Shared shell for the watchlist single-item and bulk removal confirmation
// modals — both are a plain Yes/No confirmation with the same narrower,
// rounded, header-divider-free layout instead of fe-core Modal's defaults
// (X close button, header divider, ~4.5rem title-to-body gap). Overrides
// target fe-core internals by partial class-name match — brittle vs. a
// fe-core reorg, so if these stop applying after a fe-core bump, check
// whether Header__HeaderContainer / Content / data-testid="close-modal-button"
// still exist. The `Content` selector is scoped to direct children of the
// ModalContainer so an unrelated descendant that happens to have "Content"
// in its class name isn't picked up.
export const StyledConfirmationModal = styled(Modal)`
  max-width: 34rem;
  border-radius: 0.5rem;
  [data-testid='close-modal-button'] {
    display: none;
  }
  [class*='Header__HeaderContainer'] {
    border-bottom: none;
    padding-bottom: 0.5rem;
  }
  & > [class*='Content'] {
    padding-top: 0.5rem;
    padding-bottom: 1rem;
  }
`

export const ConfirmationModalBody = styled.div`
  ${Typography.Body1}
  color: ${Colors.Semantic.Neutral.black};
`

export const ConfirmationModalNoteWarning = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  margin-top: 1.5rem;
  background: ${Colors.Semantic.Error.background};
  border: 0.0625rem solid ${Colors.Semantic.Error.highlight};
  border-radius: 0.5rem;
  ${Typography.Body2}
  color: ${Colors.Semantic.Neutral.black};
`

export const ConfirmationModalWarningIcon = styled(FontAwesomeIcon)`
  color: ${Colors.Semantic.Error.highlight};
  font-size: 1.25rem;
  flex-shrink: 0;
  margin-top: 0.125rem;
`

export const ConfirmationModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 3rem 1.5rem;
`
